export var GET_FREELANCER_MESSAGES = '[Messages] Get Freelancer Messages';
export var GET_FREELANCER_MESSAGES_SUCCESS = '[Messages] Get Freelancer Messages Success';
export var GET_FREELANCER_MESSAGES_ERROR = '[Messages] Get Freelancer Messages Error';
var GetFreelancerMessages = /** @class */ (function () {
    function GetFreelancerMessages(payload) {
        this.payload = payload;
        this.type = GET_FREELANCER_MESSAGES;
    }
    return GetFreelancerMessages;
}());
export { GetFreelancerMessages };
var GetFreelancerMessagesSuccess = /** @class */ (function () {
    function GetFreelancerMessagesSuccess(payload) {
        this.payload = payload;
        this.type = GET_FREELANCER_MESSAGES_SUCCESS;
    }
    return GetFreelancerMessagesSuccess;
}());
export { GetFreelancerMessagesSuccess };
var GetFreelancerMessagesError = /** @class */ (function () {
    function GetFreelancerMessagesError(payload) {
        this.payload = payload;
        this.type = GET_FREELANCER_MESSAGES_ERROR;
    }
    return GetFreelancerMessagesError;
}());
export { GetFreelancerMessagesError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/store/actions/messages.action.ts.pre-build-optimizer.js